var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProducts(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M50.7 58.5L225 17.4c6.5-1.5 13.3-1.5 19.8 0L419.3 58.5c9.6 2.2 16.4 10.9 16.4 20.9V464c0 26.5-21.5 48-48 48H80c-26.5 0-48-21.5-48-48V79.4c0-10 6.8-18.7 16.4-20.9z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProducts);
export default __webpack_public_path__ + "static/media/products.d975dfc69f8a4826224fdf70546350be.svg";
export { ForwardRef as ReactComponent };